import Layout from './views/Layout.vue';
// import Dashboard from './views/Dashboard.vue';
// import Users from './views/Users.vue';
// import EndUsers from './views/EndUsers.vue';
// import Videos from './views/Videos.vue';
// import AddVideo from './views/AddVideo.vue';
// import EditVideo from './views/EditVideo.vue';
// import History from './views/History.vue';
// import HistoryList from './views/HistoryList.vue';
import EmptyRouterView from './views/EmptyRouterView.vue';
// import AddTenant from './views/AddTenant.vue';
// import TenantList from './views/TenantList.vue';
// import TenantDetails from './views/TenantDetails.vue';
// import BoxLogicTester from './views/BoxLogicTester';
// import store from '@/store';
import roles from '@/utils/roles';
import store from '@/store';
const routes = [
    {
        path: '/admin',
        component: Layout,
        beforeEnter: checkUserLogin,
        redirect: 'admin/dashboard',
        meta: {
            authorize: [roles.ADMIN, roles.TRAINER, roles.SUPER_ADMIN]
        },

        children: [
            {
                path: "text-search",
                component: () => import("./views/TextSearch.vue"),
                name: "TextSearch"
            },
            {
                path: "campaign/Create",
                component: () => import("./views/CreateOrUpdateCampaign.vue"),
                name: 'CreateCampaign'
            },
            {
                path: "campaign/Update/:id",
                component: () => import("./views/CreateOrUpdateCampaign.vue"),
                name: 'UpdateCampaign'
            },

            {
                path: `campaign/:id`,
                component: () => import("./views/CampaignDetails.vue"),
                name: 'campaignById'
            }
            ,
            {
                path: "campaign",
                component: () => import("./views/CampaignList.vue"),
                name: "campaign-module"

            },
            {
                path: 'dashboard',
                component: () => import('./views/Dashboard.vue'),
                name: 'dashboard',
                meta: {
                    authorize: [roles.ADMIN, roles.TRAINER, roles.SUPER_ADMIN]
                },
            },
            {
                path: 'users',
                component: () => import('./views/Users.vue'),
                name: 'users',
                meta: {
                    authorize: [roles.ADMIN, roles.TRAINER, roles.SUPER_ADMIN]
                },
            },
            {
                path: 'end-users',
                component: () => import('./views/EndUsers.vue'),
                name: 'end-users',
                meta: {
                    authorize: [roles.ADMIN, roles.TRAINER, roles.SUPER_ADMIN]
                },
            },
            {
                path: 'videos',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        component: () => import('./views/Videos.vue'),
                        name: 'videos',
                        meta: {
                            authorize: [roles.ADMIN, roles.TRAINER, roles.VIDEO_MANAGER, roles.SUPER_ADMIN]
                        },
                    },
                    {
                        path: 'add',
                        component: () => import('./views/AddVideo.vue'),
                        name: 'addvideo',
                        meta: {
                            authorize: [roles.ADMIN, roles.TRAINER, roles.VIDEO_MANAGER, roles.SUPER_ADMIN]
                        },
                    },
                    {
                        path: 'edit/:id',
                        component: () => import('./views/EditVideo.vue'),
                        name: 'editvideo',
                        meta: {
                            authorize: [roles.ADMIN, roles.TRAINER, roles.VIDEO_MANAGER, roles.SUPER_ADMIN]
                        },
                    }
                ]
            },
            {
                path: 'history',
                component: EmptyRouterView,
                meta: {
                    authorize: [roles.ADMIN, roles.TRAINER, roles.SUPER_ADMIN]
                },
                children: [
                    {
                        path: '',
                        component: () => import('./views/HistoryList.vue'),
                        name: 'historylist',
                        meta: {
                            authorize: [roles.ADMIN, roles.TRAINER, roles.SUPER_ADMIN]
                        },
                    },
                    {
                        path: 'view',
                        component: () => import('./views/History.vue'),
                        name: 'historyview',
                        meta: {
                            authorize: [roles.ADMIN, roles.TRAINER, roles.SUPER_ADMIN]
                        },
                    }
                ]
            },
            {
                path: 'super-admin',
                component: EmptyRouterView,
                redirect: "/admin/super-admin/tenants",
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
                children: [
                    {
                        path: 'tenants/add',
                        component: () => import('./views/AddTenant.vue'),
                        name: 'addtenant',
                        meta: {
                            authorize: [roles.SUPER_ADMIN]
                        },
                    },
                    {
                        path: 'tenants/edit',
                        component: () => import('./views/AddTenant.vue'),
                        props: route => ({ tenantId: route.query.id, isEdit: true }),
                        name: 'edittenant',
                        meta: {
                            authorize: [roles.SUPER_ADMIN]
                        },

                    },
                    {
                        path: 'tenants',
                        component: () => import('./views/TenantList.vue'),
                        name: 'tenants',
                        meta: {
                            authorize: [roles.SUPER_ADMIN]
                        },
                    }
                ]
            },
            {
                path: 'tenant-information',
                component: () => import('./views/TenantDetails.vue'),
                meta: {
                    authorize: [roles.ADMIN]
                },
            },
            {
                path: 'box-logic',
                component: () => import('./views/BoxLogicTester'),
                name: 'boxlogic',
                meta: {
                    authorize: [roles.SUPER_ADMIN, roles.VIDEO_MANAGER]
                },
            },
            {
                path: 'b2b-clients',
                component: () => import('./views/B2BClients'),
                name: 'B2BClients',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            {
                path: 'programs',
                component: () => import('./views/Programs'),
                name: 'programs',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            {
                path: 'trainer-profile',
                component: EmptyRouterView,
                name: 'Trainer Profile',
                meta: {
                    authorize: [roles.ADMIN, roles.TRAINER]
                },
                children: [{
                    path: '',
                    component: () => import('./views/TrainerDashboard.vue'),
                    name: 'Trainer Dashboard',

                },
                    , {
                    path: 'videos',
                    component: () => import('./views/TrainerVideos.vue'),
                    name: 'Trainer Videos',

                },
                    , {
                    path: 'edit',
                    component: () => import('./views/TrainerEdit.vue'),
                    name: 'Trainer Edit',

                },
                ]
            },
            {
                path: "/admin/:corporate/leaderboard",
                component: () => import("./views/LeaderBoard"),
                name: "leaderboard",
                meta: {
                    title: "Leaderboard",
                }
            },
            {
                path: "/admin/:corporate/corporate-dashboard",
                component: () => import("../module_user/views/CorporateDashboard"),
                name: "CorporateDashboard",
                meta: {
                    title: "Corporate Dashboard",
                }
            },
            {
                path: 'usage-summary',
                component: () => import('./views/UsageSummary.vue'),
                name: 'usage-summary',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            {
                path: 'reporting',
                component: () => import('./views/ReportingDashboard.vue'),
                name: 'reporting',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            {
                path: 'reporting/weeklyChallenge/:id',
                component: () => import('./views/ReportingWeeklyChallenge.vue'),
                name: 'reporting-weekly-challenge',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            {
                path: 'reporting/:client/:id',
                component: () => import('./views/ReportingClientDetails.vue'),
                name: 'reporting-client-details',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },

            {
                path: '/admin/reporting/client/user/:id',
                component: () => import('./views/ReportingUserDetails.vue'),
                name: 'reporting-client-user-details',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            {
                path: 'test-report',
                component: () => import('./views/TestingReport.vue'),
                name: 'test-report',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            { 
                path: 'all-videos',
                component: () => import('./views/AllVideos.vue'),
                name: 'all-videos',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            {
                path: 'any-test',
                component: () => import('./views/AnyTesting.vue'),
                name: 'any-test',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            { 
                path: 'playback',
                component: () => import('./views/Playback.vue'),
                name: 'playback',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            {
                path: 'notification',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        component: () => import('./views/NotificationDashboard.vue'),
                        name: 'notification',
                        meta: {
                            authorize: [roles.SUPER_ADMIN]
                        },
                    },
                    {
                        path: 'add',
                        component: () => import('./views/AddNotification.vue'),
                        name: 'addNotification',
                        meta: {
                            authorize: [roles.SUPER_ADMIN]
                        },
                    },
                ]
            },
            {
                path: 'text-search',
                component: () => import('./views/TextSearch.vue'),
                name: 'TextSearch',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
             {
                path: 'support-content',
                component: () => import('./views/SupportContent.vue'),
                name: 'AdminSupportContent',
                meta: {
                    authorize: [roles.SUPER_ADMIN]
                },
            },
            
            {
                path: 'admin-notifications',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        component: () => import('./views/NotificationDashboardV2.vue'),
                        name: 'notification',
                        meta: {
                            authorize: [roles.SUPER_ADMIN]
                        },
                    },
                    {
                        path: 'add',
                        component: () => import('./views/AddNotificationV2.vue'),
                        name: 'addNotification',
                        meta: {
                            authorize: [roles.SUPER_ADMIN]
                        },
                    },
                ]
            },
        ]
    }
];

export default routes;


export async function checkUserLogin(to, from, next) {
    if (store.state.userInfo && store.state.userInfo.role && store.state.userInfo.privileges.includes('access-admin-screen')) {
        next();
    }
    else {
        next("/home");
    }
}
